const state = {
	settings: localStorage.getItem("virtuals-settings")
		? JSON.parse(localStorage.getItem("virtuals-settings"))
		: null,
};

const persistSettings = (settings) => {
	localStorage.setItem("virtuals-settings", JSON.stringify(settings));
};

const getDefaultSettings = () => {
	return Object.assign(
		{},
		{
			showMoreMarkets: true,
		}
	);
};

const getters = {
	settings: (state) => {
		return state.settings ? state.settings : getDefaultSettings();
	},
};

const mutations = {
	toggleShowMoreMarkets(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.showMoreMarkets = !settings.showMoreMarkets;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
